'use strict';

intellidealerAppCoreModule.factory('partRelatedResource', function ($resource, appConfigurationService) {
  return {
    myDealerCustomerPartRelatedDetailsByPart: $resource(appConfigurationService.basePath + '/rest/partlist/myDealerCustomerPartRelatedDetailsByPart/'),
    myDealerCustomerPartRelatedDetailsByPartAndLocation: $resource(appConfigurationService.basePath + '/rest/partlist/myDealerCustomerPartRelatedDetailsByPartAndLocation/')
  }
});
